var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJackpotTabBar = function SvgJackpotTabBar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M11.293 5H6.5v4.793zm-4.086 5.5h9.586L12 5.707zM17.5 9.793V5h-4.793zm-6.866 11.592L1.519 10.614l4.143.828zM22.48 10.614l-9.113 10.77 4.97-9.942zm.095-1.039-4.075.815V5.5zM12 21.882 17.191 11.5H6.809zM5.5 5.5 1.425 9.575l4.075.815z",
    clipRule: "evenodd"
  })));
};
export default SvgJackpotTabBar;